<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12 text-center">
        <div>
          <pulse-loader :loading="loading" :color="color" class="text-center"/>
        </div>
      </div>
      <div class="col-md-12" v-if="stores">
        <div class="card">
          <div class="card-header">
            <h5>Накладная перемещения</h5>
          </div>
          <div class="card-body ">
            <div class="row">
              <div class="col-md-4">
                <label for="">Склад отправитель:</label>
                <select @change="updateReceiverStore" :disabled="selectDisable" v-model="invoice.store_out" class="form-control">
                  <option v-for="(store, index) in stores" :value="store.id">{{store.title}}</option>
                </select>
              </div>
              <div class="col-md-4" v-if="invoice.store_out">
                <label for="">Склад получатель:</label>
                <select @change="updateDeliveryDate" :disabled="selectDisable" v-model="invoice.store_in" class="form-control">
                  <option v-for="(store, id) in stores[invoice.store_out].allowToSend.sub_value" v-if="stores[invoice.store_out]" :value="id">{{stores[id].title}}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="">Дата накладной:</label>
                <datetime
                  input-class="form-control"
                  type="datetime"
                  :minute-step="60"
                  format="dd.MM.yyyy HH:mm"
                  :auto="true"
                  :min-datetime="minDateSelect"
                  v-model="invoice.delivery_date"></datetime>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="">Комментарий:</label>
                <textarea v-model="invoice.comment" rows="2" class="form-control"></textarea>
              </div>
              <div class="col-md-6 btn_div">
                <button @click="createInvoice" class="btn btn-primary">Создать</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="invoiceDetailsVisibility" class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div>
              <invoiceDetails ref="invoiceDetails"
                :invoiceType="invoiceType"
                :invoice="invoice"
                :storeId="invoice.store_out"
                :updateDiscount="updateDiscount"
                :useCurrency="false"
              />
            </div>
            <div class="row" v-if="false">
              <div class="col-md-12">
                <hr>
              </div>
              <div class="col-md-5">
                <div class="input-group">
                  <input type="number" @change="updateDiscount" v-model="invoice.discount" class="form-control">
                </div>
                <div>
                  <div class="custom-control custom-radio">
                    <input @change="updateDiscount" type="radio" id="customRadio1" v-model="invoice.discount_type" value="1" class="custom-control-input">
                    <label class="custom-control-label" for="customRadio1">Общая сумма в валюте накладной (скидка <strong>{{discountInPercent}}%</strong>)</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input @change="updateDiscount" type="radio" id="customRadio2" v-model="invoice.discount_type" value="2" class="custom-control-input">
                    <label class="custom-control-label" for="customRadio2">Процент с каждой позиции</label>
                  </div>
                </div>
                <div>
                  <p>Общая сумма накладной без скидки: <strong>{{printTotalSum()}}</strong></p>
                  <p>Общая сумма накладной со скидкой: <strong>{{printTotalSum(true)}}</strong></p>
                </div>
              </div>
              <div class="col-md-3" v-if="invoice.discount">
                <p>Реальная скидка: <strong>{{realDiscount}}</strong></p>
                <p>Реальный %: <strong>{{realDiscountInPercent}}</strong></p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-md-6">
                <select v-if="invoiceStatuses" v-model="invoice.status" class="form-control">
                  <option v-for="(title, id) in invoiceStatuses" :value="id">{{title}}</option>
                </select>
              </div>
              <div class="col-md-6 text-right" v-if="!invoiceSaved">
                <vue-ladda @click="saveNewInvoice()" button-class="btn btn-success"
                           data-style="zoom-in"
                           :loading="btn_save_loading">Сохранить новую накладную
                </vue-ladda>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from '@/api'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'
  // import Datepicker from 'vuejs-datepicker'
  // import {en, ru} from 'vuejs-datepicker/dist/locale'

  import {Datetime} from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import {Settings} from 'luxon'

  import invoiceDetails from '@/components/invoices/invoiceDetails'

  Settings.defaultLocale = 'ru'
  import moment from 'moment'

  export default {
    components: {
      PulseLoader,
      Datetime,
      VueLadda,
      invoiceDetails,
    },
    data() {
      return {
        invoiceType: 'transit',
        stores: null,
        invoiceSaved: false,
        countriesCurrencies: null,
        invoice: {
          store_in: null,
          currency_id: null,
          type: 2,
          delivery_date: null,
          comment: null,
          discount: null,
          discount_type: 1,
          currency_alias: null,
          status: 1
        },
        invoiceStatuses: null,
        Toast: this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }),
        selectDisable: false,
        loading: true,
        color: '#007dcc',
        storesReceiver: null,
        currencies: null,
        cities: null,
        btn_save_loading: false,
        minDateSelect: null,
        currentDrugList: [],
        drugList: [],
        drugLists: {},
        invoiceDetailsVisibility: false,
        invoiceList: {
          isVisible: false,
          drugs: []
        },
        discounts: {},
        totalDiscount: 0,
        totalSum: 0,
        discountInPercent: 0,
        realDiscountInPercent: 0,
        realDiscount: 0,
      }
    },
    mounted() {
      this.getStores();
    },
    methods: {
      updateDeliveryDate() {
        let sett = this.stores[this.invoice.store_out].allowToSend.sub_value[this.invoice.store_in];
        let date = moment().add(1, 'days').set('minute', 0).format();
        if (sett.days) {
          date = moment().add(sett.days, 'days').set('hour', sett.time.split(':')[0]).set('minute', 0).format();
          console.log(sett);
        }
        this.invoice.delivery_date = date;
      },
      updateReceiverStore() {
        this.invoice.store_in = Object.keys(this.stores[this.invoice.store_out].allowToSend.sub_value)[0];
        this.updateDeliveryDate();
      },
      resetInvoice() {
        this.invoice = {
          store_in: null,
          currency_id: null,
          type: 1,
          delivery_date: null,
          comment: null,
          discount: null,
          discount_type: 1,
        };
        this.invoiceList = {
          isVisible: false,
          drugs: [{}]
        };
        this.selectDisable = false;
        let date = moment().startOf('hour').add(3, 'hours').format()
        if (moment().format('HH') > 12)
          date = moment().add(1, 'day').set('hour', 17).startOf('hour').format();

        this.invoice.delivery_date = date;
        this.invoice.store_in = Object.keys(this.storesReceiver)[0];
        this.invoice.currency_id = Object.keys(this.currencies)[0];

      },
      roundDiscount() {
        if (!this.invoice.discount) return;
        let diff = this.totalSum - this.invoice.discount;
        this.invoice.discount = +this.invoice.discount + +(diff % 1);
        this.updateDiscount();
      },
      updateDiscount(drugs = null) {
        if (drugs[0] && drugs[0].drug)
          this.invoiceList.drugs = drugs;

        if (this.invoiceType === 'transit') return;

        let sum = 0;
        this.invoiceList.drugs.forEach((d) => {
          if (!d.drug) return;
          sum = +sum + +(+(d.drug.price) * +d.drug.qty).toFixed(3);
        });
        this.totalSum = sum;

        if (!this.invoice.discount) {
          this.discountInPercent = 0;
          this.realDiscountInPercent = 0;
          // return;
        }

        if (sum == 0) return;

        if (this.invoice.discount_type == 1) {
          this.discountInPercent = (this.invoice.discount / this.totalSum * 100).toFixed(3);
        } else {
          this.discountInPercent = this.invoice.discount;
        }

        // console.log('discountPersent', this.discountInPercent);

        let discountSum = 0;

        this.invoiceList.drugs.forEach((d) => {
          if (!d.drug) return;
          d.drug.discount_price = (+d.drug.price * (100 - +this.discountInPercent) / 100).toFixed(3);
          discountSum = +discountSum + +(+(d.drug.discount_price) * +d.drug.qty).toFixed(3);
        });

        this.realDiscount = (+sum - +discountSum).toFixed(3);
        this.realDiscountInPercent = (+this.realDiscount / +sum * 100).toFixed(3)

        this.invoiceList.drugs.forEach((d) => {
          if (!d.drug) return;
          d.drug.clearedDiscountPrice = (+d.drug.price - +(+d.drug.price * +this.realDiscountInPercent / 100).toFixed(3)).toFixed(3);
        });


        this.$refs.invoiceDetails.updateDrugDiscount(this.invoiceList.drugs);

        // console.log(sum);
        // console.log(discountSum);

        // if (drugs[0] && drugs[0].drug)
        //     this.updateDiscount();

      },
      printTotalSum(discount = false) {
        let sum = 0;
        this.invoiceList.drugs.forEach((d) => {
          if (d.drug)
            sum += ((d.drug.qty || 0) * (d.drug.price || 0)).toFixed(3) * 1;
        });
        if (!discount) {
          this.totalSum = sum.toFixed(3);
          return sum.toFixed(3);
        } else {
          let discountNum = 0;

          if (this.invoice.discount_type == 1) {
            discountNum = this.invoice.discount;
          } else {
            discountNum = (this.invoice.discount * sum / 100).toFixed(3);
          }
          return (sum.toFixed(3) - discountNum).toFixed(3);
        }
      },
      async saveNewInvoice() {
        const valid = await this.$validator.validateAll();
        console.log(valid);
        if (!valid) return;

        if (this.invoiceList.drugs.length <= 1) return;
        let pass = false;
        this.invoiceList.drugs.forEach((d) => {
          if (d.drug) pass = true;
        });
        console.log(pass);
        if (!pass) return;

        this.btn_save_loading = true;
        let {data} = await api.post('/invoices/create', {
          'drugs': this.invoiceList.drugs,
          'invoice': this.invoice,
        });
        if (data.success) {
          this.Toast.fire({
            type: 'success',
            title: 'Сохранено'
          });
          this.invoiceSaved = true;

          this.mixinGoToRouter('InvoicesEdit', {id: data.invoice_id})
          // this.resetInvoice();

        } else {
          let text = '';
          if (data.errorData) {
            Object.keys(data.errorData).forEach((title) => {
              data.errorData[title].forEach((err) => {
                text += '<p>' + title + ': ' + err + '</p>';
              })
            })
          }
          this.Toast.fire({
            type: 'warning',
            title: (text ? text : data.message) || 'Ошибка'
          })
        }
        this.btn_save_loading = false;
      },
      async getStores() {
        const {data} = await api.post('/invoices/getInvoiceCreateDetails', {
          invoiceType: 'shift'
        });

        let date = moment().startOf('hour').add(3, 'hours').format()
        if (moment().format('HH') > 12)
          date = moment().add(1, 'day').set('hour', 17).startOf('hour').format();

        this.minDateSelect = moment().add(3, 'hours').format();

        this.invoice.delivery_date = date;
        this.countriesCurrencies = data.countries;
        this.storesReceiver = data.stores;
        this.currencies = data.currencies;
        this.invoiceStatuses = data.invoiceStatuses;
        this.invoice.store_in = Object.keys(this.storesReceiver)[0];
        this.invoice.currency_id = Object.keys(this.currencies)[0];
        this.stores = data.stores;
        this.loading = false;
      },
      async createInvoice() {
        if (!this.invoice.store_out || !this.invoice.store_in) return;
        // let {data} = await api.post('/invoices/getDrugsByCurrency', {
        //     'currency': this.currencies[this.invoice.currency_id]
        // });
        // this.currentDrugList = data.list;
        // console.log(this.drugLists);
        // this.drugLists[this.invoice.currency_id] = data.list;
        // console.log(this.drugLists);
        this.selectDisable = true;
        this.invoiceDetailsVisibility = true;
        this.invoice.currency_alias = this.currencies[this.invoice.currency_id];
        // this.invoiceList.isVisible = true;
      },
      addCurrencySearch(drug) {

      }
    }
  }

</script>


<style scoped>
  .flex div {
    margin-right: 15px;
  }

  .btn_div {
    position: relative;
  }

  .btn_div button {
    position: absolute;
    bottom: 0;
  }
</style>
